import type MailboxInfo from "./MailboxInfo";
import type MailboxKey from "./MailboxKey";
import getAccountKeyForMailboxInfo from "./getAccountKeyForMailboxInfo";
import { defaultAccountKey } from "./AccountKey";

/**
 * Provides a string that can be used for in-memory mailbox key of MailboxInfo in a map or other
 * structure where data needs to be indexed based upon the mailbox.
 *
 * @param mailboxInfo MailboxInfo for which the mailbox key is to be returned
 * @returns MailboxKey for the MailboxInfo
 */
export default function getMailboxKeyForMailboxInfo(mailboxInfo: MailboxInfo): MailboxKey {
    const mailboxKey = mailboxInfo.sourceId ?? regenerateMailboxKey(mailboxInfo);
    return mailboxKey as MailboxKey;
}

// This function is used to generate the sourceID for the mailboxInfo object OUTSIDE of the
// account source list store which is a hack and should not be used in the future.
// Once WI: https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/345674 is completed,
// this function shall be replaced with a new function that uses the account source list store.
function regenerateMailboxKey(mailboxInfo: MailboxInfo): MailboxKey {
    const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
    const mailboxSmtpAddress = mailboxInfo.explicitLogonMailboxSmtpAddress ?? mailboxInfo.mailboxSmtpAddress;
    
    return `${accountKey}:${mailboxSmtpAddress}` as MailboxKey;
}

/**
 * Determines if the specified mailbox key is tied to the default account key.
 * */
export function isDefaultMailboxKey(mailboxKey: MailboxKey): boolean {
    return mailboxKey.startsWith(defaultAccountKey);
}
